import { Controller } from "@hotwired/stimulus"

// Tap the app-version footer 5 times to reveal the hidden server-version line
// (a small diagnostic affordance, mirroring iOS Settings' build-number tap).
// Taps must land within RESET_MS of each other or the count restarts.
const TAPS_REQUIRED = 5
const RESET_MS = 2000

export default class extends Controller {
  static targets = ["server"]

  connect() {
    this.count = 0
  }

  tap() {
    if (this.serverTarget.classList.contains("hidden") === false) return

    clearTimeout(this.timer)
    this.count += 1
    if (this.count >= TAPS_REQUIRED) {
      this.serverTarget.classList.remove("hidden")
      this.count = 0
      return
    }
    this.timer = setTimeout(() => { this.count = 0 }, RESET_MS)
  }

  disconnect() {
    clearTimeout(this.timer)
  }
}
